import { API_CALL } from 'actions/actionConstants'
import * as SearchService from 'api/search'
import { FETCH_MAX_SAVINGS } from './apiActionConstants'

export function fetchMaxSavings(region: string, placeIds: string[], filter: App.DestinationSelectedFilters) {
  return (dispatch) => {
    dispatch({
      type: API_CALL,
      api: FETCH_MAX_SAVINGS,
      filter,
      request: () => SearchService.getDestinationMaxSavings(region, placeIds, filter),
    })
  }
}
